// extracted by mini-css-extract-plugin
module.exports = {"notice":"ChooseEntityNotice_notice__19744"};